// extracted by mini-css-extract-plugin
export default {"savedAddress":"SavedAddress-module__savedAddress___1ZkDd","pencil":"SavedAddress-module__pencil___1I05L"};